import { useEffect } from 'react';
import { getFrameworkState, useSliceAction, genSliceStateSelector, genGetSliceState } from '../utils';
import { osuiCssVarsSlice } from './reduxSlice';
import { isHookAvailable, setThemeDataAttr } from './utils';
export { initOSUICssVarsStore } from './initOSUICssVarsStore';
export var useSetOSUICssVersion = function useSetOSUICssVersion() {
  /** 设置osui的版本 */
  var setOSUICssVersion = useSliceAction(osuiCssVarsSlice.actions.setOSUICssVersion);
  var setState = useSliceAction(osuiCssVarsSlice.actions.setState);
  return {
    setOSUICssVersion: setOSUICssVersion,
    setState: setState
  };
};
/** 设置osui的css变量版本 */

export var useOSUICssVersion = function useOSUICssVersion(version) {
  if (!isHookAvailable()) {
    return;
  }
  /* eslint-disable react-hooks/rules-of-hooks */


  var _useSetOSUICssVersion = useSetOSUICssVersion(),
      setOSUICssVersion = _useSetOSUICssVersion.setOSUICssVersion;

  useEffect(function () {
    var lastVersion = getFrameworkState()[osuiCssVarsSlice.name].version;
    setOSUICssVersion(version);
    return function () {
      setOSUICssVersion(lastVersion);
    };
  }, [setOSUICssVersion, version]);
  /* eslint-enable react-hooks/rules-of-hooks */
};
/** 设置osui的css变量版本 */

export var useOSUICssState = function useOSUICssState(state) {
  if (!isHookAvailable()) {
    setThemeDataAttr(state.themeDataAttr);
    return;
  }
  /* eslint-disable react-hooks/rules-of-hooks */


  var _useSetOSUICssVersion2 = useSetOSUICssVersion(),
      setState = _useSetOSUICssVersion2.setState;

  useEffect(function () {
    var lastState = getFrameworkState()[osuiCssVarsSlice.name];
    setState(state);
    return function () {
      setState(lastState);
    };
  }, [setState, state]);
  /* eslint-enable react-hooks/rules-of-hooks */
};
/** 获取当前设置的osui的css var版本 */

export var useOSUICssVersionState = genSliceStateSelector(osuiCssVarsSlice);
export var getOSUICssVersionState = genGetSliceState(osuiCssVarsSlice);
//# sourceMappingURL=es/loadOSUICssVars/index.js.map